import React from 'react';

// Shared modal shell for the RAI request/confirm dialogs: a fixed dark backdrop
// with a centred white card. Click the backdrop to dismiss; clicks inside the
// card are swallowed. zIndex/maxWidth let a confirm dialog layer above the
// request dialog it was opened from.
const ModalShell = ({ children, onClose, labelledBy, zIndex = 1000, maxWidth = 540 }) => (
  <div
    role="dialog"
    aria-modal="true"
    aria-labelledby={labelledBy}
    onClick={onClose}
    style={{
      position: 'fixed',
      top: 0, left: 0, right: 0, bottom: 0,
      background: 'rgba(0,0,0,0.5)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      zIndex,
    }}
  >
    <div
      onClick={(e) => e.stopPropagation()}
      style={{ background: 'white', borderRadius: 8, padding: 24, maxWidth, width: '90%' }}
    >
      {children}
    </div>
  </div>
);

export default ModalShell;
